// extracted by mini-css-extract-plugin
export default {"panel":"ConditionPanel_panel__x6pS8","panel-extended":"ConditionPanel_panel-extended__Lb23g"};